<template>
  <v-container class="pt-0 full-height">
    <div v-if="!isDispatching" class="pa-5" style="min-height: 100vh;">
      <header class="mb-6">
        <h1 class="text-h4 font-weight-bold primary--text mb-1">
          Gestión de Entregas
        </h1>
        <p class="grey--text text--darken-1 mb-0">
          Control operativo para la liberación de pedidos pendientes
        </p>
      </header>

      <DeliverySearchBar
        :initial-search="currentParams.search"
        :initial-start="currentParams.start_date"
        :initial-end="currentParams.end_date"
        :initial-status="currentParams.status_id"
        :current-tab="currentTab"
        @search="handleSearch"
        class="mb-4"
      />

      <DeliveryTable
        :store-id="selectedStoreId"
        :initial-tab="currentTab"
        :pendingItems="pendingList"
        :historyItems="historyList"
        :loading="isLoading"
        :historyLoading="isHistoryLoading"
        :pendingCount="totalPendingCount"
        @change-tab="handleTabChange"
        @pagination-change="handlePagination"
        ref="deliveryTable"
        @error="handleError"
      />
    </div>
  </v-container>
</template>

<script>
import Swal from 'sweetalert2';
import DeliverySearchBar from '@/components/Deliveries/DeliverySearchBar.vue';
import DeliveryTable from '@/components/Deliveries/DeliveryTable.vue';

export default {
  /* eslint-disable no-console */
  name: 'DeliveriesView',
  components: {
    DeliverySearchBar,
    DeliveryTable,
  },
  data() {
    return {
      isLoading: false,
      isHistoryLoading: false,
      pendingList: [],
      historyList: [],
      totalPendingCount: 0,

      // Parámetros activos de la petición
      currentParams: {
        store_id: null,
        search: null,
        start_date: null,
        end_date: null,
        status_id: null,
        limit: 20,
        offset: 0,
      },
      currentTab: 'pending', // 'pending' o 'history'
      isDispatching: false,
      selectedOrder: null,
    };
  },
  computed: {
    selectedStoreId() {
      return this.currentParams.store_id || this.$store.getters.currentStoreId;
    },
  },
  created() {
    this.readStateFromUrl();
  },
  async mounted() {
    await this.fetchData();
  },
  watch: {
    '$route.query': function $routeQuery() {
      this.readStateFromUrl();
      this.fetchData();
    },
  },
  methods: {
    readStateFromUrl() {
      const q = this.$route.query;
      this.currentTab = q.tab || 'pending';

      this.currentParams.search = q.search || null;
      this.currentParams.start_date = q.start_date || null;
      this.currentParams.end_date = q.end_date || null;
      this.currentParams.status_id = q.status_id ? Number(q.status_id) : null;
      this.currentParams.limit = Number(q.limit) || 20;
      this.currentParams.offset = Number(q.offset) || 0;
    },
    updateUrlQuery() {
      const query = {
        tab: this.currentTab !== 'pending' ? this.currentTab : undefined,
        search: this.currentParams.search || undefined,
        start_date: this.currentParams.start_date || undefined,
        end_date: this.currentParams.end_date || undefined,
        status_id: this.currentParams.status_id || undefined,
        limit: this.currentParams.limit !== 20 ? this.currentParams.limit : undefined,
        offset: this.currentParams.offset !== 0 ? this.currentParams.offset : undefined,
      };

      // router.replace evita llenar el historial del navegador con clicks repetidos
      this.$router.replace({ query }).catch(() => {});
    },
    async fetchData() {
      const storeId = this.$store.getters.currentStoreId;
      if (!storeId) return;

      this.currentParams.store_id = storeId;

      this.$nextTick(() => {
        if (this.$refs.deliveryTable) {
          this.$refs.deliveryTable.triggerFetch(this.currentTab, this.currentParams);
        }
      });
    },

    // Método que reacciona cuando el usuario teclea algo en el buscador
    handleSearch(filters) {
      this.currentParams.search = filters.search || null;
      this.currentParams.start_date = filters.startDate || null;
      this.currentParams.end_date = filters.endDate || null;
      this.currentParams.status_id = filters.statusId || null;
      this.currentParams.offset = 0;

      this.updateUrlQuery();
      this.fetchData();
    },

    handleTabChange(tabName) {
      if (this.currentTab === tabName) return;
      this.currentTab = tabName;
      this.currentParams.offset = 0;

      this.updateUrlQuery();
      this.fetchData();
    },

    handlePagination({ limit, offset }) {
      if (this.currentParams.limit !== limit || this.currentParams.offset !== offset) {
        this.currentParams.limit = limit;
        this.currentParams.offset = offset;

        this.updateUrlQuery();
        this.fetchData();
      }
    },

    handleError(message) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: message,
        confirmButtonColor: 'primary',
      });
    },
    openDispatchModal(item) {
      this.$router.push({
        name: 'OrderDispatch',
        params: { folio: item.folio },

        query: {
          store_id: this.currentParams.store_id,
          status_id: item.statusId,
          status_desc: item.statusDescription,
        },
      });
    },
    closeDispatch() {
      this.isDispatching = false;
      this.selectedOrder = null;
    },
    handleDispatchComplete() {
      this.isDispatching = false;
      this.selectedOrder = null;
      this.fetchData();
    },
  },
};
</script>
